import React, { ReactChild, ReactNode, useState } from 'react';
import './PopConfirmButton.less';
import Button, { ButtonProps } from '../Button/Button';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog, ConfirmContentType } from '../ConfirmDialog';

interface PopConfirmButtonPropsType {
    children: ReactChild | ReactChild[] | ReactNode | string;
    isConfirmed?: boolean;
    okText?: string;
    cancelText?: string;
    type?: ConfirmContentType;
    title?: ReactNode | string;
    content?: ReactNode | string;
    onClick?: () => void;
    showIcon?: boolean;
}

const PopConfirmButton = ({
    children,
    title,
    content,
    isConfirmed,
    onClick,
    showIcon = true,
    okText,
    cancelText,
    type = ConfirmContentType.WARNING,
    ...buttonProps
}: PopConfirmButtonPropsType & ButtonProps) => {
    const [isOpen, setOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <div
            className={classNames('pop-confirm-button', {
                'cursor-pointer': !buttonProps.disabled,
                'cursor-not-allowed': buttonProps.disabled,
            })}
        >
            <ConfirmDialog
                type={type}
                okText={okText || t('common.dialog.ok')}
                cancelText={cancelText || t('common.dialog.abort')}
                open={isOpen}
                title={title}
                showIcon={showIcon}
                onOk={() => {
                    setOpen(false);
                    if (onClick) onClick();
                }}
                onCancel={() => {
                    setOpen(false);
                }}
                content={content}
            />
            <Button
                {...buttonProps}
                onClick={() => {
                    if (isConfirmed) {
                        if (onClick) onClick();
                        setOpen(false);
                    } else {
                        setOpen(true);
                    }
                }}
            >
                {children}
            </Button>
        </div>
    );
};

export default PopConfirmButton;
